export default "__VITE_ASSET__f9ad988d__"